<!-- Header -->
<div class="page-heading-blue">
    <div class="pt-4 pl-4">
        <span>{{ 'PROGRAM' | translate }} <i class="fal fa-angle-right"></i></span>
    </div>
    <div class="row p-4" *ngIf="!loading && program">
        <div class="col-4">
            <h2>{{ program.name }}</h2>
            <br>
            <span>{{'PROGRAM-LEAD' | translate}}: {{program.leader.name}}</span>
        </div>
        <div class="col-6">
            {{ program.description }}
        </div>
        <div class="col-2">
            <button class="btn btn-outline-light" (click)="backToProgramEdit()">
                {{ 'BACK-TO-PROGRAM-EDIT' | translate }}
                <i class="arrow fal fa-angle-right"></i>
            </button>
        </div>
    </div>
</div>

<!-- Body -->
<div class="content-background">
    <h5 class="pt-2 pb-2">
        <span class="montserrat font-weight-bold text-uppercase">{{'PROGRAM-OVERVIEW' | translate}}</span>
    </h5>
    <!--No Program Metrics-->
    <div class="h-100">
        <div class="row">
            <div class="col text-left afont-weight-bold mt-2" style="margin-top: auto; color: rgba(0, 0, 0, 0.50);"
                *ngIf="!loading && programMetrics.length === 0">
                {{'NO-PROGRAM-METRICS' | translate}}
            </div>
        </div>
        <div class="row justify-content-center" *ngIf="loading">
            <span class="k-icon k-i-loading kendo-loading-icon"></span>
        </div>
    </div>
    <div class="row" *ngIf="!loading && programMetrics.length > 0">
        <!-- Program metrics statistics -->
        <div class="col-xl-4 col-md-6 col-xs-12 pl-2 pb-2" *ngFor="let item of programMetrics">
            <div class="card m-2 h-100 text-center">
                <div class="card-body d-flex justify-content-center row" style="min-height:200px;">
                    <div class="row w-100 align-self-center">
                        <!--Values-->
                        <div class="col-4 m-0 p-0" [ngClass]="{'col-6': item.rate === null}">
                            <span class="dash-numeric">{{item.numeratorValue}}</span>
                        </div>
                        <div class="col-4 m-0 p-0" [ngClass]="{'col-6': item.rate === null}">
                            <span class="dash-numeric">{{item.denominatorValue}}</span>
                        </div>
                        <div class="col-4 m-0 p-0" *ngIf="item.rate !== null">
                            <span class="dash-numeric">{{item.rate | number:'1.0-1'}}</span>
                        </div>
                    </div>
                    <div class="row w-100 align-self-center">
                        <!--Labels-->
                        <div class="col-4 m-0 p-0" [ngClass]="{'col-6': item.rate === null}">
                            <span class="dash-label">{{item.numeratorDescription}}</span>
                        </div>
                        <div class="col-4 m-0 p-0" [ngClass]="{'col-6': item.rate === null}">
                            <span class="dash-label">{{item.denominatorDescription}}</span>
                        </div>
                        <div class="col-4 m-0 p-0" *ngIf="item.rate !== null">
                            <span class="dash-label">{{'RATE'|translate}}</span>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <h4 class="montserrat">{{ item.name | uppercase }} <span kendoTooltip position="top"
                            class="keyboard-accessible" tabindex="0" showOn="none" aria-live="polite"
                            (focus)="showTooltip(descriptionTooltip)" (mouseover)="showTooltip(descriptionTooltip)"
                            (blur)="hideTooltip()" (mouseout)="hideTooltip()">
                            <a #descriptionTooltip title="{{item.description}}"><i
                                    class="fa fa-info-circle pointer"></i>
                            </a>
                        </span>
                    </h4>
                </div>
            </div>
        </div>
    </div>
</div>